module.exports = __webpack_public_path__ + "static/media/melanie.3791e59c.jpg";